import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { makeCopy } from '#common/functions/make-copy';
import type { Fraction } from '#common/zod/blockml/fraction';
import type { FractionControl } from '#common/zod/blockml/fraction-control';
import type { EventFractionUpdate } from '#common/zod/front/event-fraction-update';

@Component({
  standalone: false,
  selector: 'm-store-fraction-switch',
  templateUrl: 'store-fraction-switch.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreFractionSwitchComponent {
  @Input() fraction: Fraction;
  @Input() isFirst: boolean;
  @Input() fractionIndex: number;
  @Input() isDisabled: boolean;
  @Input() fractionControl: FractionControl;

  @Output() fractionUpdate = new EventEmitter<EventFractionUpdate>();

  constructor(private fb: FormBuilder) {}

  emitFractionUpdate() {
    this.fractionUpdate.emit({
      fraction: this.fraction,
      fractionIndex: this.fractionIndex
    });
  }

  toggleSwitch() {
    let newControl = makeCopy(this.fractionControl);

    newControl.value = !newControl.value;

    let newFraction = makeCopy(this.fraction);

    let controlIndex = newFraction.controls.findIndex(
      control => control.name === this.fractionControl.name
    );

    newFraction.controls = [
      ...newFraction.controls.slice(0, controlIndex),
      newControl,
      ...newFraction.controls.slice(controlIndex + 1)
    ];

    this.fraction = newFraction;

    this.emitFractionUpdate();
  }
}
